import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Dropdown, Input } from 'antd'
import Popover from '@components/common/Popover'
import ColorPicker from '@components/ColorPicker'
import Select from '@components/common/Select'
import { notifyAlert } from '@components/notification'
import _ from 'lodash'

export const SQUARE_GRADATION_COLORS = [
  ['#DEF3FF', '#45ADFF'],
  ['#FBCE4F', '#FB6F67'],
  ['#E2F4DF', '#2CD781'],
  ['#FCD7D2', '#FB6F67'],
]

export const CUBE_GRADATION_COLORS = [
  ['#45ADFF', '#DEF3FF', '#FB6F67'],
  ['#2CD781', '#FBCE4F', '#F76B1C'],
  ['#FEFCF1', '#FAD961', '#2CD781'],
  ['#DEF3FF', '#45ADFF', '#2CD781'],
]

const CUSTOM_TYPES = [
  { value: 'min', label: '最小值' },
  { value: 'median', label: '中间值' },
  { value: 'max', label: '最大值' },
]

const getCustomTypes = (i, length) => {
  if (length === 2 && i === 1) return CUSTOM_TYPES[2]
  return CUSTOM_TYPES[i]
}

const VALUE_FIXED_TYPE = { value: 'fixed', label: '固定数值' }

// export const NUMBER_REG = /-?(\d+|\d+\.\d+|\.\d+)([eE][-+]?\d+)?/
export const NUMBER_REG = /^[-]?[0-9]+[.][0-9]+|[-]?[0-9]+$/

export const getGradationBackground = (gradationColors) => {
  let background
  if (Array.isArray(gradationColors) && gradationColors.length === 2) {
    background = `linear-gradient(90deg, ${gradationColors[0]} 0%, ${gradationColors[1]} 100%)`
  } else if (Array.isArray(gradationColors) && gradationColors.length === 3) {
    background = `linear-gradient(90deg, ${gradationColors[0]} 0%, ${gradationColors[1]} 50% ,${gradationColors[2]} 100%)`
  }
  return background
}

class GradationValue extends React.Component {
  input = React.createRef()

  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    index: PropTypes.number,
    i: PropTypes.number,
    onGradationChange: PropTypes.func,
    colors: PropTypes.array,
  }

  render() {
    const { value, index, i, onGradationChange, colors } = this.props

    return (
      <div className="select-wrapper">
        {!['min', 'max', 'median'].includes(value) && <Input
          ref={this.input}
          value={value}
          placeholder="请输入"
          onBlur={this.handleBlur}
          onKeyDown={this.handleInputKeyDown.bind(this, index, i)}
          onChange={e => onGradationChange(index, 'value', i, e.target.value, this.handleInputChange)}
          type="number"
        /> }

        <Select
          value={['min', 'max', 'median'].includes(value) ? value : 'fixed'}
          dropdownClassName="gradation-value-select-dropdown"
          onChange={val => onGradationChange(index, 'value', i, val, this.handleFocusInput)}
        >
          {
            [getCustomTypes(i, colors.length), VALUE_FIXED_TYPE].map(type => (
              <Select.Option key={type.value} value={type.value}>{type.label}</Select.Option>
            ))
          }
        </Select>
      </div>
    )
  }

  // 特殊处理 e
  handleInputKeyDown(index, i, e) {
    const { onGradationChange } = this.props

    if (e.key && e.key.toLowerCase() === 'e') {
      onGradationChange(index, 'value', i, e.target.value, this.handleInputChange)
    }
  }

  handleFocusInput = () => {
    setTimeout(() => {
      const { value } = this.props
      if (['min', 'max', 'median'].includes(value)) {
        return
      }
      this.focus()
    }, 0)
  }

  focus(reset = false) {
    if (this.input && this.input.current) {
      this.input.current.focus()
      if (reset) {
        this.input.current.input.value = ''
      }
    }
  }

  handleInputChange = _.debounce((originValue, value, index) => {
    if (!NUMBER_REG.test(value[index])) {
      notifyAlert('', '请输入合法的数字')
      this.focus(true)
    }
  }, 300)

  handleBlur = (e) => {
    const { index, i, onGradationChange, colors } = this.props

    let v = e.target.value

    if (!NUMBER_REG.test(v)) {
      const defaultValue = getCustomTypes(i, colors.length)
      v = defaultValue.value
    }
    onGradationChange(index, 'value', i, v)
  }
}

class GradationStyle extends Component {
  static defaultProps = {}

  static propTypes = {
    condition: PropTypes.shape({
      visible: PropTypes.bool,

    }),
    index: PropTypes.number,
    handleChangeVisible: PropTypes.func,
    onColorPickerSure: PropTypes.func,
    onColorPickerHide: PropTypes.func,
    onGradationChange: PropTypes.func,
  }

  render() {
    const { condition, handleChangeVisible } = this.props
    const { visible, styles } = condition
    const { color, gradation_colors: gradationColors } = styles

    return (
      <div className="cell" style={{ width: 50, flex: 0, flexShrink: 0 }}>
        <Dropdown
          trigger={['click']}
          overlay={this.renderColorMenu()}
          placement='bottomLeft'
          visible={visible}
          onVisibleChange={handleChangeVisible}
        >
          <div className="config-style-wrapper">
            {
              this.renderIcon(color, gradationColors)
            }
          </div>
        </Dropdown>
      </div>
    )
  }

  renderColorMenu() {
    const { condition, index, onColorPickerSure, onColorPickerHide, onGradationChange } = this.props
    const { value } = condition
    const { color, gradation_colors: gradationColors } = condition.styles
    const options = condition.operator === 'cube' ? CUBE_GRADATION_COLORS : SQUARE_GRADATION_COLORS

    const inSelect = options.map(d => d.join(',')).includes(gradationColors.join(','))

    return (
      <div
        className="cells-dropdown-overlay gradation-style-setting"
        style={{ width: condition.operator === 'cube' ? 468 : 320, height: 170 }}>
        <div className="gradation-color-wrapper">
          <div className="color-select">
            <Select
              value={inSelect ? gradationColors.join(',') : (
                <div style={{ background: getGradationBackground(gradationColors) }}>
                  <i className="iconfont-date-filter icon-date-filter-default" style={{ color }}/>
                </div>
              )}
              // value={gradationColors.join(',')}
              dropdownClassName={`gradation-color-select-dropdown${condition.operator === 'cube' ? ' cube' : ''}`}
              onChange={d => onColorPickerSure(index, 'gradation_colors', d)}
            >
              {options.map(d => (<Select.Option key={d.join(',')} value={d.join(',')}>
                <div style={{ background: getGradationBackground(d) }}>
                  <i className="iconfont-date-filter icon-date-filter-default" style={{ color }}/>
                </div>
              </Select.Option>))}
            </Select>
          </div>
          <div className="value-select">
            {
              gradationColors.map((d, i) => (
                <div key={i} className="value-select-inner">
                  <Popover
                    content={
                      <ColorPicker
                        color={d || 'transparent'}
                        changeAtOnce={false}
                        onSure={c => onGradationChange(index, 'color', i, c)}
                        onHide={onColorPickerHide}
                        disableAlpha={false}
                      />
                    }
                    trigger="click"
                    overlayStyle={{ zIndex: 1060 }}
                    placement="bottomLeft"
                    className="table-cell-config-color-picker-popover-container"
                    align={{ targetOffset: [0, 2] }}
                  >
                    <span className="custom-option-round" style={{ background: d || 'transparent' }}/>
                  </Popover>

                  <GradationValue
                    onGradationChange={onGradationChange}
                    value={value[i]}
                    index={index}
                    i={i}
                    colors={gradationColors}
                  />
                </div>
              ))
            }
          </div>
        </div>
        <hr/>
        <div className="color-wrapper">
          <Popover
            content={
              <ColorPicker
                color={color || 'transparent'}
                changeAtOnce={false}
                onSure={d => onColorPickerSure(index, 'color', d)}
                onHide={onColorPickerHide}
                disableAlpha={false}
              />
            }
            trigger="click"
            overlayStyle={{ zIndex: 1060 }}
            placement="bottomLeft"
            className="table-cell-config-color-picker-popover-container"
          >
            <span className="custom-option-round" style={{ background: color || 'transparent' }}/>
          </Popover>
          <span className="custom-option-label">文字</span>
        </div>
      </div>
    )
  }

  renderIcon(color, gradationColors) {
    const background = getGradationBackground(gradationColors)

    return (<span className="config-gradation-wrapper" style={{ background }}>
      <i className="iconfont-date-filter icon-date-filter-default" style={{ color }}/>
    </span>)
  }
}

export default GradationStyle
